import React, { useContext } from 'react';
import './FinalizeRegistration.scss';

const RegistrationFinalize = () => {
  return (
    <div className="finalize-registration-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration</h1>
      </div>

      <div className="child-form form-group">
        <h2 className="page-subtitle">Congratulations!</h2>
        <p>
          Your registration has now been sent to our database and you will
          receive an email invitation to LeapFrog Lab's Product Testing sessions
          when our teams require participants with your family's
          characteristics.
        </p>
        <p>We look forward to your visit!</p>
        <p>--Your friends at LeapFrog</p>
      </div>
    </div>
  );
};

export default RegistrationFinalize;
